<template>
    <div>
         <md-table v-model="chartData" md-sort="value" md-sort-order="desc" md-card>

      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Opciones" md-sort-by="name">{{ item.name }}</md-table-cell>
        <md-table-cell md-label="Cant." md-sort-by="value">{{ item.value }}</md-table-cell>
        <md-table-cell md-label="%" md-sort-by="percentage">{{ item.percentage }}</md-table-cell>
      </md-table-row>
    </md-table>
    </div>
</template>



<script>
    export default {
        name: "TableQuestion",
        props: {
            chartData: {
                type: Array,
                default: () => {
                    return [];
                }
            }
    },
        components: {
        }
    };
</script>


<style lang="scss" scoped>
    .md-table-cell {
        padding: 10px 8px;
        font-size: 12px;
        height: initial;
    }
</style>
